export const formatShortDateTime = (dateValue) => {
  if (!dateValue) return '';
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date);
};

const FIELD_LABELS = {
  first_name: 'First name',
  last_name: 'Last name',
  email: 'Email',
  username: 'Username',
  phone: 'Phone',
  roles: 'Roles',
  is_active: 'Active',
  avatar: 'Profile picture',
};

const formatBoolean = (value) => (value === true || value === 'true' ? 'Yes' : value === false || value === 'false' ? 'No' : String(value));

const formatFieldValue = (field, value) => {
  if (value === null || value === undefined || value === '') return 'empty';
  if (field === 'is_active') return formatBoolean(value);
  if (field === 'roles') {
    if (Array.isArray(value)) {
      return value.length ? value.join(', ') : 'empty';
    }
    return String(value);
  }
  if (typeof value === 'boolean') return formatBoolean(value);
  return String(value);
};

const formatChanges = (changes = []) => {
  if (!Array.isArray(changes) || changes.length === 0) return null;
  return changes
    .map((change) => {
      const field = FIELD_LABELS[change.field] || change.field;
      const fromValue = formatFieldValue(change.field, change.from);
      const toValue = formatFieldValue(change.field, change.to);
      return `${field}: ${fromValue} -> ${toValue}`;
    })
    .join('\n');
};

const ACTION_MESSAGES = {
  'user.created': 'User created',
  'user.profile_updated': 'Profile updated',
  'user.roles_updated': 'Roles updated',
  'user.status_updated': 'Status updated',
  'user.avatar_updated': 'Profile picture updated',
  'user.avatar_deleted': 'Profile picture removed',
  'user.membership_added': 'Added to company',
  'user.membership_removed': 'Removed from company',
};

export const formatUserLogEntry = (log) => {
  if (!log) return '';
  const base = ACTION_MESSAGES[log.action] || log.action || 'Activity';
  const changesText = formatChanges(log.metadata?.changes);
  if (changesText) return `${base}\n${changesText}`;

  if (log.action === 'user.created' || log.action === 'user.membership_added' || log.action === 'user.membership_removed') {
    const parts = [];
    if (log.metadata?.email) parts.push(`Email: ${log.metadata.email}`);
    if (log.metadata?.username) parts.push(`Username: ${log.metadata.username}`);
    if (Array.isArray(log.metadata?.roles) && log.metadata.roles.length) {
      parts.push(`Roles: ${log.metadata.roles.join(', ')}`);
    }
    if (parts.length) return `${base}\n${parts.join('\n')}`;
  }

  return base;
};
